import { ThemeProvider, createTheme, useTheme } from "@mui/material/styles";
import { RoofPanelPage } from "./RoofPanelPage";
import { eqpThemeExtension } from "../../shared/theme";

const RoofPanel = () => {
  const baseTheme = useTheme();

  // Create extended theme with EAF colors
  const extendedTheme = createTheme({
    ...baseTheme,
    palette: {
      ...baseTheme.palette,
      ...eqpThemeExtension.palette,
    },
  });

  return (
    <ThemeProvider theme={extendedTheme}>
      <RoofPanelPage />
    </ThemeProvider>
  );
};

export default RoofPanel;
